
import { useState } from 'react';
import { SchemaOrg } from '../../../utils/seo';

const faqs = [
  {
    id: 1,
    question: '保険の相談は無料ですか?',
    answer: 'はい、完全無料です。何度でもご相談いただけます。岡山市・倉敷市・総社市への出張相談も無料で承っております。お気軽にお問い合わせください。',
  },
  {
    id: 2,
    question: '岡山市以外でも相談できますか?',
    answer: 'もちろんです。岡山市を中心に、倉敷市、総社市、玉野市、瀬戸内市など近隣市町村への出張相談を行っております。お客様のご都合の良い場所までお伺いいたします。',
  },
  {
    id: 3,
    question: 'どのような保険を取り扱っていますか?',
    answer: '生命保険、医療保険、がん保険、自動車保険、火災保険、地震保険、個人年金保険、学資保険など、幅広く取り扱っております。複数の保険会社の商品を比較してご提案できます。',
  },
  {
    id: 4,
    question: '保険の見直しだけでも相談できますか?',
    answer: 'はい、もちろんです。現在ご加入中の保険内容を確認し、ライフステージの変化に合わせた最適なプランをご提案いたします。無理な勧誘は一切いたしません。',
  },
  {
    id: 5,
    question: '相談にはどのくらい時間がかかりますか?',
    answer: '初回のご相談は1時間〜1時間半程度です。お客様のご状況やご要望をじっくりお伺いし、最適なプランをご提案いたします。お時間に余裕を持ってお越しください。',
  },
];

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-24 bg-[#FAF8F3]">
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C3E50] mb-4 px-4">
            よくあるご質問
          </h2>
          <p className="text-gray-600 text-base md:text-lg">
            岡山市の保険代理店に寄せられるご質問
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl overflow-hidden shadow-sm"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-6 md:px-8 py-5 md:py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-base md:text-lg font-bold text-[#2C3E50] pr-4 leading-snug">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-[#FF9B7A] transition-transform ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-6 md:px-8 pb-5 md:pb-6">
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
